import s from './discovery.scss';
export var selectorButtonsClassNamesV1 = {
    selectorButton: s.selectorButton,
    selectorButtonSelected: s.selectorButtonSelected,
    selectorButtonUnselected: s.selectorButtonUnselected,
    selectorTitleAnimation: s.selectorTitleAnimation,
    selectorButtonsAnimation: s.selectorButtonsAnimation,
};
export var selectorButtonsClassNamesV2 = {
    selectorButton: s.selectorButtonNew,
    selectorButtonSelected: s.selectorButtonSelectedNew,
    selectorButtonUnselected: s.selectorButtonUnselectedNew,
    selectorTitleAnimation: s.selectorTitleAnimationNew,
    selectorButtonsAnimation: s.selectorButtonsAnimationNew,
};
//# sourceMappingURL=types.js.map